import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
    state: {
        user: false,
        username:'',
        menulist:[],
        ruleslist:[]
    },
    mutations: {
        // 登录
        login(state, user) {
            state.user = user;
            localStorage.setItem("userInfo", user);
        },
        // 退出
        logout(state, user) {
            state.user = "";
            localStorage.clear();
            localStorage.setItem("userInfo", "");
        },
        // 用户名
        SET_NAME: (state, username) => {
            state.username = username
        },
        // 菜单
        SET_MENU: (state, menus) => {
            state.menulist = menus
        },
        // 权限控制按钮列表
        SET_RULE: (state, rules) => {
            state.ruleslist = rules
        }
    }
})


// WEBPACK FOOTER //
// ./src/vuex/store.js